/*
 * Taken from here:
 * https://github.com/amrlabib/react-timer-hook/blob/master/src/hooks/useInterval.js
 */
import { useEffect, useRef } from 'react'

export default function useInterval(callback: () => void, delay: number | null | undefined): void {
  const callbackRef = useRef<() => void>()

  // update callback function with current render callback
  // that has access to latest props and state
  useEffect(() => {
    callbackRef.current = callback
  })

  useEffect(() => {
    if (!delay) {
      return () => {}
    }

    const interval = setInterval(() => {
      callbackRef.current && callbackRef.current()
    }, delay)
    return () => clearInterval(interval)
  }, [delay])
}
